<template>
  <div v-if="current">
    
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field label="Nome"  dense solo v-model="query" @click:append="search()" append-icon="mdi-magnify" v-on:keyup.enter="search()"></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <v-alert dense text type="info">
          {{ counter }} registros
        </v-alert>
      </v-col>
      <v-col cols="12" sm="1" v-if="!$auth.isSubuser()">
        <v-btn color="primary" @click="register()" block >+</v-btn>
      </v-col>
    </v-row>
    
    <v-simple-table>
      <thead>
        <tr>
          <th>Nome</th>
          <th>Download</th>
          <th>Upload</th>
          <th>Preço</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.name }}</td>
          <td>{{ item.download }}</td>
          <td>{{ item.upload }}</td>
          <td>R$ {{ item.price | formatMoney }}</td>
          <td><v-btn icon :to="`/plan/${item.id}`"><v-icon>mdi-magnify</v-icon></v-btn></td>
        </tr>
      </tbody>
    </v-simple-table>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import api from '../../api/index.js';
import router from '../../router/index.js';
export default {
  data: () => ({
    current: null,
    counter: 0,
    query: "",
    dialog_loading: false
  }),
  created: function() {
    this.count();
    this.list();
  },
  methods: {
    count: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api.get("/plan/count", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.counter = response.data;
      })
      .catch(function(error) {
        alert("Falha ao recuperar contagem!");
        console.log(error);
      });
    },
    list: function() {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api.get("/plan", {headers: { Authorization: "Bearer " + token }})
      .then(function(response) {
        me.dialog_loading = false;
        me.current = response.data;
      })
      .catch(function(error) {
        me.dialog_loading = false;
        console.log(error);
        alert("Falha ao recuperar listagem!");
      });
    },
    details: function(item) {
      router.push({ path: `/plan/${item.id}` });
    },
    register: function (){
      router.push({ path: "/plan/new" });
    },
    search: function() {
      var me = this;
      if(me.query==""){
        this.count();
        return;
      }
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/plan/name/"+this.query, { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.dialog_loading = false;
          me.current = response.data;
          me.counter = response.data.length;
        })
        .catch(function(error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao buscar registros!");
        });
    },
    colorType: function(item){
      var color = "default";
      if (item.type==1){
        color = "warning";
      }else if(item.type==2){
        color = "success";
      }else if(item.type==3){
        color = "error";
      }
      return color;
    }
  },
  filters: {
    formatType: function(item){
      var text = "desconhecido";
      if (item.type==1){
        text = "Voz";
      }else if(item.type==2){
        text = "SMS";
      }else if(item.type==3){
        text = "Internet";
      }
      return text;
    }
  }
};
</script>